import { toast } from "react-hot-toast";
import { clearAuth, setLoading, setToken } from "../../redux/slices/authSlice";
import { setUser } from "../../redux/slices/profileSlice";
import { apiConnector } from "../apiconnector";
import { endpoints } from "../apis";
const API_BASE = process.env.REACT_APP_API_URL;
const { SIGNUP_API,EMPLOYEESIGNUP_API,LOGIN_API, RESETPASSTOKEN_API, RESETPASSWORD_API } = endpoints;

// ✅ Corrected signup function
export function signUp(signupData, navigate) {
  return async (dispatch) => {
    const toastId = toast.loading("Loading...");
    dispatch(setLoading(true));

    try {
      const response = await apiConnector("POST", SIGNUP_API, signupData);
      // console.log("SIGNUP API RESPONSE:", response);

      if (!response.success) {
        throw new Error(response.message);
      }

      toast.success("Signup Successful");
      navigate("/features", { state: { email: response.user.email } });

    } catch (error) {
      console.error("SIGNUP API ERROR:", error);
      toast.error(error.response?.data?.message || "Signup Failed");
      navigate("/signup");
    }

    dispatch(setLoading(false));
    toast.dismiss(toastId);
  };
}

export function employeeSignUp(signupData, navigate) {
  return async (dispatch) => {
    const toastId = toast.loading("Loading...");
    dispatch(setLoading(true));

    try {
      const response = await apiConnector("POST", EMPLOYEESIGNUP_API, signupData);
      // console.log("EMPLOYEESIGNUP API RESPONSE:", response);

      if (!response.success) {
        throw new Error(response.message);
      }

      toast.success("Signup Successful");
      navigate("/login");

    } catch (error) {
      console.error("SIGNUP API ERROR:", error);
      toast.error(error.response?.data?.message || "Signup Failed");
      navigate(`/signup?email=${signupData.email}`);
    }

    dispatch(setLoading(false));
    toast.dismiss(toastId);
  };
}

export function checkAuth(dispatch) {
  return async () => {
      dispatch(setLoading(true));
      try {
        const response = await apiConnector("GET", `${API_BASE}/auth/me`, null, {
          withCredentials: true,
        });
  
        if (response.success) {
          dispatch(setUser(response.user));
          dispatch(setToken("cookie")); 
        } else {
          dispatch(clearAuth());
        }
      } catch (err) {
        dispatch(clearAuth());
      } finally {
        dispatch(setLoading(false));
      }
    };
}

// ✅ Corrected login function
export function login(email, password, navigate) {
  return async (dispatch) => {
    const toastId = toast.loading("Loading...");
    dispatch(setLoading(true));

    try {
      const response = await apiConnector(
        "POST",
        LOGIN_API,
        { email, password },
        { withCredentials: true } // important for cookies
      );

      if (!response.success) {
        throw new Error(response.message);
      }
      await dispatch(checkAuth(dispatch));

      toast.success("Login Successful");

      // Update Redux state (authenticated + user profile)
      dispatch(setToken("cookie")); // placeholder just to flip state


    } catch (error) {
      console.error("LOGIN API ERROR:", error);
      toast.error(error.response?.data?.message || "Login Failed");
    }

    dispatch(setLoading(false));
    toast.dismiss(toastId);
  };
}


// ✅ Logout function
export function logout(navigate) {
  return async (dispatch) => {
    try {
      await apiConnector("POST", `${API_BASE}/auth/logout`, {}, { withCredentials: true });
    } catch (err) {
      console.error("LOGOUT ERROR:", err);
    }
    dispatch(setToken(null))
    dispatch(setUser(null));
    
    toast.success("Logged Out");
    navigate("/");
  };
}


// ✅ Get password reset token
export function getPasswordResetToken(email, setEmailSent) {
  return async (dispatch) => {
    dispatch(setLoading(true));

    try {
      const response = await apiConnector("POST", RESETPASSTOKEN_API, { email });
      // console.log("RESET PASSWORD TOKEN RESPONSE:", response);

      if (!response.success) {
        throw new Error(response.message);
      }

      toast.success("Reset Email Sent");
      setEmailSent(true);

    } catch (error) {
      console.error("RESET PASSWORD TOKEN Error:", error);
      toast.error("Failed to send email for resetting password");
    }

    dispatch(setLoading(false));
  };
}

// ✅ Reset password function
export function resetPassword(password, confirmPassword, token) {
  return async (dispatch) => {
    dispatch(setLoading(true));

    try {
      const response = await apiConnector("POST", RESETPASSWORD_API, {
        password,
        confirmPassword,
        token,
      });

      // console.log("RESET PASSWORD RESPONSE:", response);

      if (!response.success) {
        throw new Error(response.message);
      }

      toast.success("Password has been reset successfully");

    } catch (error) {
      console.error("RESET PASSWORD ERROR:", error);
      toast.error("Unable to reset password");
    }

    dispatch(setLoading(false));
  };
}







// import { toast } from "react-hot-toast"

// import { setLoading, setToken } from "../../slices/authSlice"
// // import { resetCart } from "../../slices/cartSlice"
// import { setUser } from "../../slices/profileSlice"
// import { apiConnector } from "../apiconnector"
// import { endpoints } from "../apis"
// const {
//     SIGNUP_API,
//     LOGIN_API,
//     RESETPASSTOKEN_API,
//     RESETPASSWORD_API,
//   } = endpoints


// // export function signUp(
// //     firstName,
// //     lastName,
// //     company,
// //     email,
// //     password,
// //     confirmPassword,
// //     remember,
// //     navigate
// //   ) {
// //     return async (dispatch) => {
// //       const toastId = toast.loading("Loading...")
// //       dispatch(setLoading(true))
// //       try {
// //         const response = await apiConnector("POST", SIGNUP_API, {
// //           firstName,
// //           lastName,
// //           email,
// //           password,
// //           confirmPassword,
// //           company,
// //           remember,
// //         })
  
// //         console.log("SIGNUP API RESPONSE............", response)
  
// //         if (!response.data.success) {
// //           throw new Error(response.data.message)
// //         }
// //         toast.success("Signup Successful")
// //         navigate("/features")
// //       } catch (error) {
// //         console.log("SIGNUP API ERROR............", error)
// //         toast.error("Signup Failed")
// //         navigate("/signup")
// //       }
// //       dispatch(setLoading(false))
// //       toast.dismiss(toastId)
// //     }
// //   }
// export function signUp(signupData, navigate) {
//   return async (dispatch) => {
//     const toastId = toast.loading("Loading...")
//     dispatch(setLoading(true))
//     try {
//       const response = await apiConnector("POST", SIGNUP_API, {
//         ...signupData,
//       })

//       console.log("SIGNUP API RESPONSE............", response)

//       if (!response.data.success) {
//         throw new Error(response.data.message)
//       }
//       toast.success("Signup Successful")
//       console.log(response.data.user.email)
//       navigate("/features", { state: { email: response.data.user.email } })
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Signup Failed")
//       console.log("SIGNUP API ERROR............", error)

//       navigate("/signup")
//     }
//     dispatch(setLoading(false))
//     toast.dismiss(toastId)
//   }
// }
  

//   // export function login(email, password, navigate) {
//   //   return async (dispatch) => {
//   //     const toastId = toast.loading("Loading...")
//   //     dispatch(setLoading(true))
//   //     try {
//   //       const response = await apiConnector("POST", LOGIN_API, {
//   //         email,
//   //         password,
//   //       })
  
//   //       console.log("LOGIN API RESPONSE............", response)
  
//   //       if (!response.data.success) {
//   //         throw new Error(response.data.message)
//   //       }
  
//   //       toast.success("Login Successful")
//   //       dispatch(setToken(response.data.token))
//   //       const userImage = response.data?.user?.image
//   //         ? response.data.user.image
//   //         : `https://api.dicebear.com/5.x/initials/svg?seed=${response.data.user.firstName} ${response.data.user.lastName}`
//   //       dispatch(setUser({ ...response.data.user, image: userImage }))
        
//   //       localStorage.setItem("token", JSON.stringify(response.data.token))
//   //       localStorage.setItem("user", JSON.stringify(response.data.user))
//   //       navigate("/dashboard/my-profile")
//   //     } catch (error) {
//   //       console.log("LOGIN API ERROR............", error)
//   //       toast.error("Login Failed")
//   //     }
//   //     dispatch(setLoading(false))
//   //     toast.dismiss(toastId)
//   //   }
//   // }
//   export function login(email, password, navigate) {
//     return async (dispatch) => {
//       const toastId = toast.loading("Loading...");
//       dispatch(setLoading(true));
//       try {
//         const response = await apiConnector("POST", LOGIN_API, {
//           email,
//           password,
//         });
  
//         console.log("LOGIN API RESPONSE............", response);
  
//         if (!response.data.success) {
//           throw new Error(response.data.message);
//         }
  
//         toast.success("Login Successful");
//         dispatch(setToken(response.data.token));
//         const userImage = response.data?.user?.image
//           ? response.data.user.image
//           : `https://api.dicebear.com/5.x/initials/svg?seed=${response.data.user.firstName} ${response.data.user.lastName}`;
//         dispatch(setUser({ ...response.data.user, image: userImage }));
  
//         localStorage.setItem("token", JSON.stringify(response.data.token));
//         localStorage.setItem("user", JSON.stringify(response.data.user));
  
//         const user = response.data.user;
//         if (user.isAdmin === false) {
//           navigate("/features", { state: { email: user.email } });
//         } else if (user.isAdmin === true) {
//           navigate("/admin-dashboard");
//         } else if (user.isEmployee === true) {
//           navigate("/employee-dashboard");
//         } else {
//           navigate("/dashboard/my-profile");
//         }
  
//       } catch (error) {
//         console.log("LOGIN API ERROR............", error?.response?.data || error);
//         toast.error(error?.response?.data?.message || "Login Failed");
//       }
//       dispatch(setLoading(false));
//       toast.dismiss(toastId);
//     };
//   }
  
  

//   export function logout(navigate) {
//     return (dispatch) => {
//       dispatch(setToken(null))
//       dispatch(setUser(null))
//     //   dispatch(resetCart())
//       localStorage.removeItem("token")
//       localStorage.removeItem("user")
//       toast.success("Logged Out")
//       navigate("/")
//     }
//   }
  
  
  
//   export function getPasswordResetToken(email , setEmailSent) {
//     return async(dispatch) => {
//       dispatch(setLoading(true));
//       try{
//         const response = await apiConnector("POST", RESETPASSTOKEN_API, {email,})
  
//         console.log("RESET PASSWORD TOKEN RESPONSE....", response);
  
//         if(!response.data.success) {
//           throw new Error(response.data.message);
//         }
  
//         toast.success("Reset Email Sent");
//         setEmailSent(true);
//       }
//       catch(error) {
//         console.log("RESET PASSWORD TOKEN Error", error);
//         toast.error("Failed to send email for resetting password");
//       }
//       dispatch(setLoading(false));
//     }
//   }
  
//   export function resetPassword(password, confirmPassword, token) {
//     return async(dispatch) => {
//       dispatch(setLoading(true));
//       try{
//         const response = await apiConnector("POST", RESETPASSWORD_API, {password, confirmPassword, token});
  
//         console.log("RESET Password RESPONSE ... ", response);
  
  
//         if(!response.data.success) {
//           throw new Error(response.data.message);
//         }
  
//         toast.success("Password has been reset successfully");
//       }
//       catch(error) {
//         console.log("RESET PASSWORD TOKEN Error", error);
//         toast.error("Unable to reset password");
//       }
//       dispatch(setLoading(false));
//     }
//   }

